module.exports = __webpack_public_path__ + "img/title-bg-long.ad4630cb.png";